import { Header, Group, createStyles, Space, useMantineTheme, Button } from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import { Link } from "react-router-dom";
import { ReactComponent as Logo } from '../../assets/logo.svg';
import { useLocation } from 'react-router-dom'
import UserMenu from "../user-menu/user-menu.component";
import { IconMenu2, IconX } from "@tabler/icons-react";

const useStyles = createStyles((theme) => ({

    appHeader: {
        display: 'flex',
        alignItems: 'center',
        height: '100%',
        justifyContent: 'space-between',
        border: 'none',
        // maxWidth:'1200px',
        margin: '0px auto',
        background: 'none',

    },

    svgIcon: {
        width: '27px',
        height: '27px',
        margin: '0px',
        padding: '0px',
        display: 'block',
    },

    signUpButton: {
        height: '35px',
        width: '150px',
        // background: theme.colors.green[6],
        '&:active': {
            transform: 'none'
        }
    },

    subtleButton: {
        height: '35px',
        width: '90px',
        padding: '0px',
        '&:active': {
            transform: 'none'
        },
    },

    leftIconWrapper: {
        marginLeft: '25px',
    },

    rightIconWrapper: {
        marginRight: '25px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },

    buttonLink: {
        background: 'transparent',
        display: 'block',
        lineHeight: 1,
        padding: '8px 12px',
        height: '35px',
        textDecoration: 'none',
        color: theme.colors.gray[6],
        fontSize: theme.fontSizes.sm,
        fontWeight: 500,

        '&:hover': {
            // outline
            backgroundColor: 'initial',
            color: theme.colors.dark,
        },

        '&:active': {
            transform: 'none'
        },

        '.mantine-Button-leftIcon': {
            padding: 0,
            margin: 0
        }
    },

    linkActive: {
        '&, &:hover': {
            color: 'white',
            backgroundColor: theme.colors.dark[5],
        },
    },
}));

const AppHeader = ({ expandedMobileMenu, setExpandedMobileMenu, textLinks, currentUser }) => {

    const location = useLocation();

    const { classes, cx } = useStyles();

    const theme = useMantineTheme();
    const isSmall = useMediaQuery(`(max-width: ${theme.breakpoints.sm}px)`);
    const isMedium = useMediaQuery(`(max-width: ${theme.breakpoints.md}px)`);

    const ShownIcon = expandedMobileMenu ? IconX : IconMenu2;

    const close = () => { setExpandedMobileMenu(false) };
    
    return (
        <>
            <Header height={55} withBorder>
                <div className={classes.appHeader}>
                    {
                        isSmall ?
                            // Mobile
                            <>
                                <div className={classes.leftIconWrapper}>
                                    <Link to='/dashboard' onClick={close}>
                                        <Logo className={classes.svgIcon} />
                                    </Link>
                                </div>
                                <div className={classes.rightIconWrapper}>
                                    <ShownIcon
                                        onClick={() => setExpandedMobileMenu(!expandedMobileMenu)}
                                        stroke={1.5}
                                        size={25}
                                    />
                                </div>
                            </>
                            :
                            // Desktop
                            <>
                                <div className={classes.leftIconWrapper}>
                                    <Group spacing={isMedium ? 'xs' : 'md'}>
                                        <Link to='/dashboard' onClick={close}>
                                            <Logo className={classes.svgIcon} />
                                        </Link>
                                        <Space h='xs' />
                                        {
                                            currentUser && 
                                            textLinks.map(link => (
                                                <Button
                                                    key={link.text}
                                                    component={link.type === 'internal' ? Link : 'a'}
                                                    href={link.type === 'external' ? currentUser ? link.to : link.noUserTo : null}
                                                    to={link.type === 'internal' ? currentUser ? link.to : link.noUserTo : null}
                                                    target={link.type === 'external' ? '_blank' : null}
                                                    leftIcon={link.icon}
                                                    className={cx(classes.buttonLink, { [classes.linkActive]: location.pathname.includes(link.to) })}
                                                    radius='md'
                                                >
                                                    <Space w='xs' />
                                                    {link.text}
                                                </Button>
                                            ))
                                        }
                                    </Group>
                                </div>
                                <div className={classes.rightIconWrapper}>
                                    <Group spacing={isMedium ? 'xs' : 'md'}>
                                        {
                                            currentUser
                                                ?
                                                <>
                                                    <UserMenu userEmail={currentUser.email} />
                                                </>
                                                :
                                                <>
                                                    <Button
                                                        component={Link}
                                                        size='md'
                                                        className={classes.subtleButton}
                                                        to='/sign-in'
                                                        variant='subtle'
                                                        radius='md'

                                                    >
                                                        Sign in
                                                    </Button>
                                                    <Button
                                                        component={Link}
                                                        size='md'
                                                        className={classes.signUpButton}
                                                        to='/sign-up'
                                                        radius='md'
                                                        variant='outline'
                                                    >
                                                        Sign up
                                                    </Button>
                                                </>
                                        }
                                    </Group>
                                </div>
                            </>
                    }
                </div>
            </Header>
        </>
    )
}

export default AppHeader;